import React from 'react';
import { Box } from '@mui/material';

interface PageContentAreaProps {
  isPanelOpen: boolean;
  panel?: React.ReactNode;
  children: React.ReactNode;
}

export const PageContentArea: React.FC<PageContentAreaProps> = ({
  isPanelOpen,
  panel,
  children,
}) => {
  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <Box
        sx={{
          flex: '1 1 auto',
          backgroundColor: 'background.default',
          marginRight: isPanelOpen ? 'var(--panel-width)' : 0,
          transition: 'margin-right 0.2s ease',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          overflowX: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
          }}
        >
          {children}
        </Box>
      </Box>

      {panel}
    </Box>
  );
};
